import { Base64 } from 'js-base64';

export default {
/* 存储方法 */
  setItem(key, value) {
    const encodeKey = Base64.encode(key);
    const encodeValue = Base64.encode(JSON.stringify(value));
    localStorage.setItem(encodeKey, encodeValue)
  },
  getItem(key) {
     const encodeKey = Base64.encode(key);
     const localValue = localStorage.getItem(encodeKey);
     if(localValue) {
       return JSON.parse(Base64.decode(localValue))
     } else {
       return null
     }
  },
  clearItem(key) {
    const encodeKey = Base64.encode(key);
    localStorage.removeItem(encodeKey)
  },
}